/**
 * @desc getRoleAndSubordinateAndSameLevelByCode
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(
  params: API.ucenter.userFacadeImpl.getRoleAndSubordinateAndSameLevelByCode.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/user/getRoleAndSubordinateAndSameLevelByCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
